import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import simpleApi from 'app/services/simpleApi'

import laneStatusRequests from 'app/requests/Lane/LaneStatus.requests'

const useSetAsInactive = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessInactive,
        onError,
    } = useHandleStatusRequest({
        id: 'SetAsInactive',
        title: 'Set As Inactive',
        onSuccess,
    })

    return useMutation({
        mutationFn: (laneId: number) => {
            return simpleApi({
                ...laneStatusRequests.setAsInactive({
                    id: laneId,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessInactive,
    })
}

export default useSetAsInactive
